<template>
    <ContentCard theme="navy" icon="assets/images/illu-grass.svg">
        <template #title>Can we make Kangaroo<br> Grass bread? </template>
        <template #description>
            Explore the world of native Australian grasses and find out what our bread could look
            like soon!
        </template>
        <template #buttons>
            <ButtonPill icon="play" class="card__btn me-8"
                        @click.native="$store.commit('SET_LIGHTBOX', 'WAw6NnuOQ10')">Watch Now
            </ButtonPill>
            <ButtonPill href="/pdfs/What-is-in-my-grain.pdf" target="_blank" icon="file"
                        class="card__btn" orange>ACTIVITY
            </ButtonPill>
        </template>
    </ContentCard>
</template>

<script>
import ContentCard from '@/components/ContentCard';
import ButtonPill from '@/components/ButtonPill';
export default {
    components: {ButtonPill, ContentCard}
};
</script>
